export default __webpack_public_path__ + "static/3-7bf31323d352e168a54e26df759045e7.jpeg";